module.exports = __webpack_public_path__ + "static/media/private-cremation-qld.7d923aef.png";